import RMSImageMultiSize from '../RMSImageMultiSize'

const rmsMultiSizeImgValid = (multiSizeImg?: RMSImageMultiSize) => {
  return !(!multiSizeImg || multiSizeImg.image_versions.length == 0)
}

export default rmsMultiSizeImgValid
